"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DealTypeToJSON = exports.DealTypeFromJSONTyped = exports.DealTypeFromJSON = exports.DealType = void 0;
/**
 * Deal type.
 * @export
 */
exports.DealType = {
    Guaranteed: 'PROGRAMMATIC_GUARANTEED',
    MarketPlace: 'PROGRAMMATIC_MARKET_PLACE'
};
function DealTypeFromJSON(json) {
    return DealTypeFromJSONTyped(json, false);
}
exports.DealTypeFromJSON = DealTypeFromJSON;
function DealTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.DealTypeFromJSONTyped = DealTypeFromJSONTyped;
function DealTypeToJSON(value) {
    return value;
}
exports.DealTypeToJSON = DealTypeToJSON;
